import { ExtendableError } from './extendable_error.error'
import { EventDispatcher } from '../events/event_dispatcher'
import { i18n } from '../i18n'

export class TransactionError extends ExtendableError {
  constructor (message, code) {
    super(`Tx error: ${code}: ${message}`)
    this.errorType = 'TransactionError'
    this.getTranslate(message)
  }

  showBanner () {
    EventDispatcher.dispatchShowErrorEvent(this.message)
    return true
  }

  getTranslate (message) {
    switch (message) {
      case 'Token already exists':
        this.message = i18n.token_already_exists()
        break
      default:
        this.message = message
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/errors/transaction.error.js